import { Box, Typography } from "@mui/material";
import { StyledDirectoryList } from "./DirectoryList.styled";
import { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../../globals/LanguageContext";
import { Directory } from "../../../models/Directory";
import { ContextMenu } from "../../contextMenu/ContextMenu";
import { DirectoryRow } from "./DirectoryRow";
import { TreeRow } from "../../../models/global/Types";

type DirectoryListProps = {
  directory?: Directory;
  onChange: () => void;
  treeVersion: number;
};

export const DirectoryList = ({
  directory,
  onChange,
  treeVersion,
}: DirectoryListProps) => {
  const { dictionary } = useContext(LanguageContext);
  const [openedContextMenu, setOpenedContextMenu] = useState<{
    row: TreeRow;
    id: number;
  } | null>(null);

  return (
    <StyledDirectoryList>
      <Box className="head">
        <Typography variant="h3">
          {dictionary.pages.projects.project.files.title}
        </Typography>
      </Box>
      {directory && <Box className="content" onClick={() =>  {}}>
        <DirectoryRow
          row={{ type: "directory", data: directory }}
          openedContextMenu={openedContextMenu}
          depth={0}
          key={directory.id + "-" + directory.directories.length}
          treeVersion={treeVersion}
          onChange={onChange}
          onClick={() => openedContextMenu && setOpenedContextMenu(null)}
          onContextMenu={(row) =>
            setOpenedContextMenu(() => {
              if (row.data.id === openedContextMenu?.id) return null;
              return {
                row: row,
                id: row.type === "directory" ? row.data.id : row.data.id,
              };
            })
          }
        />
      </Box>}
    </StyledDirectoryList>
  );
};
